import React from 'react';
import { DumbbellIcon, FileTextIcon, TargetIcon, UsersIcon } from 'lucide-react';
import { coverageTags, readyStats } from '../data/content';
const icons = {
  file: FileTextIcon,
  dumbbell: DumbbellIcon,
  target: TargetIcon,
  users: UsersIcon
};
export function BasketballReadyStats() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-17" data-mp="1t07b3nrq48g0">
      <div className="mx-auto w-full max-w-5xl" data-id="element-18" data-mp="1t1s5nde1frdv">
        <div className="flex justify-center" data-id="element-19" data-mp="waq8xiry94j2">
          <p className="rounded-full bg-ink px-5 py-2.5 text-center text-[11px] font-bold uppercase tracking-[0.08em] text-white sm:text-xs" data-id="element-20" data-mp="wc1eno4ygmct">
            🏆 The complete system to stop improvising basketball training
          </p>
        </div>

        <h2 className="mt-8 text-center text-4xl font-extrabold uppercase tracking-tight text-neutral-900 sm:text-5xl" data-id="element-21" data-mp="1aaiwj586j4mt">
          Basketball <span className="text-ember" data-id="element-22" data-mp="2gpa3nqnwblpa">Ready 360™</span>
        </h2>

        <p className="mt-4 text-center text-sm font-bold uppercase tracking-[0.18em] text-ember" data-id="element-23" data-mp="2lnldi1e6xw7i">
          — 6 Volumes + 5 Bonuses —
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-neutral-700" data-id="element-24" data-mp="1s3cxgkyvnb93">
          Over 300 pages. 200+ professional sessions. 101 drills. Tactics. Physical
          Preparation. Team Management.{' '}
          <strong className="font-extrabold text-neutral-900" data-id="element-25" data-mp="1d8ybqcnxhnqq">Everything ready.</strong>
        </p>

        <div className="mt-10 grid grid-cols-2 gap-5 md:grid-cols-4" data-id="element-26" data-mp="197d353iffvmc">
          {readyStats.map(stat => {
          const Icon = icons[stat.icon as keyof typeof icons];
          return <div key={stat.label} className="rounded-2xl border border-neutral-200 bg-neutral-50 px-4 py-7 text-center" data-id="element-27" data-mp="zgighy19qu0d">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-ember-soft" data-id="element-28" data-mp="ug45q88a95yn">
                  <Icon className="h-5 w-5 text-ember" aria-hidden="true" data-id="element-29" data-mp="lh9293wmi9z1" />
                </span>
                <p className="mt-4 text-3xl font-extrabold tracking-tight text-neutral-900" data-id="element-30" data-mp="aw5ciejlzuym">
                  {stat.value}
                </p>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-neutral-600" data-id="element-31" data-mp="fw1fcagklgcl">
                  {stat.label}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-10 rounded-2xl border border-neutral-200 bg-neutral-50 px-5 py-8" data-id="element-32" data-mp="6v3gs7owi11e">
          <p className="text-center text-xs font-bold uppercase tracking-[0.18em] text-neutral-900" data-id="element-33" data-mp="uko390k9jgff">
            Full coverage, every category
          </p>
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-34" data-mp="kuusu2vux7cr">
            {coverageTags.map(tag => <li key={tag} className="flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-sm font-bold text-neutral-900" data-id="element-35" data-mp="pse918c47u7c">
                <span aria-hidden="true" className="text-grass" data-id="element-36" data-mp="1iaifbfwrd0ym">
                  ✔
                </span>
                {tag}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}